export const routeItems = Object.freeze({
    create_sample_order_route: "/orders/create-sample-order",
    create_order_route: "/orders/create-order",
    sample_orders_route: "/orders/sample-orders",
    customer_orders_route: "/orders/customer-orders",
    sample_invoice_route: "/orders/sample-invoice",
    customer_order_invoice_route: "/orders/order-invoice",
    customize_order_route: "/orders/customize-order",
    customize_sample_order_route: "/orders/customize-sample-order",
    single_customer_orders_route: "/orders/customer-order",
    order_detail_route: "/order-detail",
    sample_order_detail_route: "/sample-order-detail",

    scheduled_deliveries_route: "/deliveries/scheduled",
    upcoming_deliveries_route: "/deliveries/upcoming",
    incomplete_deliveries_route: "/deliveries/incomplete",
    onroute_deliveries_route: "/deliveries/onroute",

    automated_statements_route: "/finance/automated-statements",
    manual_statements_route: "/finance/manual-statements",
    pending_payments_route: "/finance/pending",
    processed_payments_route: "/finance/processed",
    statement_logs_route: "/finance/statement-logs",
    credit_note_route: "/finance/credit-note-generation",
    single_credit_note_route: "/finance/credit-note",
    bulk_payment_processing: "/finance/bulk-payment-processing",

    warehouses_route: "/warehouses",
    single_warehouse_stock_route: "/warehouses/single-warehouse-stock",

    shipments_route: "/shipments",
    record_shipment_route: "/shipments/record-shipment",

    stock_route: "/stock",
    adjusted_stock_route: "/stock/adjusted-stock",

    add_product_route: "/products/add",
    products_route: "/products",
    single_product_route: "/product",

    sales_profile_route: "/sales-profiles",
    create_sales_profile_route: "/sales-profiles/create-sales-profiles",
    all_customers_route: "/customers",
    add_customer_route: "/customers/add-new-customer",
    single_customer_route: "/customer",
    single_sales_profile_route: "/profile",
    single_branch_route: "/branch",

    add_staff_route: "/add-system-users",
    staff_route: "/system-users",
    single_staff_route: "/system-user",

    user_roles_route: "/user-roles",
    single_user_role_route: "/user-role",

    automated_tasks_route: "/automated-tasks",
    system_settings_route: "/system-settings",
    user_settings_route: "/user-settings",

    turnover_reports_route: "/reports/turnover",
    sales_reports_route: "/reports/sales",
    orders_and_deliveries_reports_route: "/reports/orders-and-deliveries",
    finance_reports_route: "/reports/finance",
    stock_reports_route: "/reports/stock",
    customers_reports_route: "/reports/customers"

});
